import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIcons500pxComponent } from './simple-icons-500px.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIcons500pxComponent ],
    exports:      [ SimpleIcons500pxComponent ],
    bootstrap:    []
})
export class SimpleIcons500pxModule {}
